import React from 'react';
import PropTypes from 'prop-types';
import img$2 from './VerisureLogoLogin.svg.js';
import img$1 from './logoFalck.png.js';
import img from './logoAlertAlarm.svg.js';
import styles from './AppLogo.module.scss.js';

var subsidiaries = {
  Falck: img$1,
  AlertAlarm: img
};
function AppLogo(_ref) {
  var subsidiary = _ref.subsidiary;
  return /*#__PURE__*/React.createElement("img", {
    id: "appLogo",
    src: subsidiaries[subsidiary] || img$2,
    className: styles.logo,
    alt: subsidiary ? "".concat(subsidiary, " logo") : 'Verisure logo'
  });
}
AppLogo.propTypes = {
  subsidiary: PropTypes.oneOf(Object.keys(subsidiaries))
};
AppLogo.defaultProps = {
  subsidiary: null
};

export { AppLogo as default };
